import { render, staticRenderFns } from "./subDatarequest.vue?vue&type=template&id=068ddc76&scoped=true&"
import script from "./subDatarequest.vue?vue&type=script&lang=js&"
export * from "./subDatarequest.vue?vue&type=script&lang=js&"
import style0 from "./subDatarequest.vue?vue&type=style&index=0&id=068ddc76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ddc76",
  null
  
)

export default component.exports